import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { modalStyles } from 'utils/modalDesignSystem';

const Modal = ({
  children,
  title,
  onClose,
  width = '500px',
  height = 'auto'
}) => {
  const [mouseDownOnOverlay, setMouseDownOnOverlay] = useState(false);

  // 오버레이에서 mousedown 시작 여부 추적
  const handleOverlayMouseDown = (e) => {
    if (e.target === e.currentTarget) {
      setMouseDownOnOverlay(true);
    }
  };

  // mousedown과 mouseup이 모두 overlay에서 발생했을 때만 모달 닫기
  const handleOverlayMouseUp = (e) => {
    if (e.target === e.currentTarget && mouseDownOnOverlay) {
      onClose();
    }
    setMouseDownOnOverlay(false);
  };

  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div
      style={modalStyles.overlay}
      onMouseDown={handleOverlayMouseDown}
      onMouseUp={handleOverlayMouseUp}
    >
      <div style={{
        ...modalStyles.container,
        width,
        height
      }}>
        {title && (
          <div style={modalStyles.header}>
            <h3 style={modalStyles.title}>{title}</h3>
            <button
              style={modalStyles.closeButton}
              onClick={onClose}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f1f5f9';
                e.target.style.color = '#374151';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#6b7280';
              }}
            >
              <FaTimes />
            </button>
          </div>
        )}
        <div style={modalStyles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
